import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user'
import workspace from './modules/workspace'
import file from './modules/file'
import help from './modules/help'

import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    workspace,
    file,
    help
  },
  state: {
    device: 'desktop',
    labelLayerShape: {
      canvasTop: 0,
      canvasLeft: 0,
      canvasWidth: 0,
      canvasHeight: 0
    }
  },
  mutations: {
    reShapeLabelLayer (state, payload) {
      state.labelLayerShape = payload
    },
    toggleDevice: (state, device) => {
      state.device = device
    }
  },
  actions: {
  },
  getters
})
